module.exports = __webpack_public_path__ + "static/img/static/img/pre_left.2d40c991.png";